export default [
  {
    path: '/pcindex',
    name: 'Main',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../../views/pcviews/Main.vue'),
    beforeUpdate:(to,from,next)=>{
      console.log(to.query,from);
      next()
    },
    children: [
      {
        path: 'video',
        name: 'Video',
        component: () => import('../../views/pcviews/Video.vue')
      },
      {
        path: 'zhead', // 片头
        name: 'Zhead',
        component: () => import('../../views/pcviews/Zhead.vue')
      },
      {
        path: 'ztail', // 片尾
        name: 'Ztail',
        component: () => import('../../views/pcviews/Ztail.vue')
      },
      {
        path: 'test',
        name: 'Test',
        component: () => import('../../views/pcviews/Test.vue'),
        children: [
          {
            path: 'single', // 单选
            name: 'Single',
            component: () => import('../../views/pcviews/Single.vue')
          },
          {
            path: 'fillblank', // 填空
            name: 'Fillblank',
            component: () => import('../../views/pcviews/FillBlank.vue')
          },
          {
            path: 'morelineBlank', // 多行填空
            name: 'MorelineBlank',
            component: () => import('../../views/pcviews/MorelineBlank.vue')
          },
          {
            path: 'drag', // 拖拽
            name: 'Drag',
            component: () => import('../../views/pcviews/Drag.vue')
          },
          {
            path: 'question', // 问答
            name: 'Question',
            component: () => import('../../views/pcviews/Question.vue')
          },
          {
            path: 'judge', // 判断
            name: 'judge',
            component: () => import('../../views/pcviews/Judge.vue')
          },
          
        ]
      },
      {
        path:'tuwen',
        name:'tuwen',
        component: () => import('../../views/pcviews/PicTxt.vue')
      },
      {
        path: 'preview', // 文档预览
        name: 'Preview',
        component: () => import('../../views/pcviews/Preview.vue')
      }
    ]
  }
]
